export function SearchIcon () {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#F5F6FA"/>
      <path
        d="M19.1667 25.8333C22.8486 25.8333 25.8333 22.8486 25.8333 19.1667C25.8333 15.4848 22.8486 12.5 19.1667 12.5C15.4848 12.5 12.5 15.4848 12.5 19.1667C12.5 22.8486 15.4848 25.8333 19.1667 25.8333Z"
        stroke="#9B9B9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M27.5 27.5L23.875 23.875" stroke="#9B9B9B" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
  )
}